const { PublicApiConfig, PublicApi } = require('paragon-dash-api-client');

export const getApiConfig = (apiServer, publicApiKey, timeoutInMs) => {
    if (!apiServer) {
        throw new Error('Please set an apiServer');
    }

    if (!publicApiKey) {
        throw new Error('Please set an publicApiKey');
    }

    const apiConfig = new PublicApiConfig({
        apiServer,
        publicApiKey,
        timeoutInMs
    });
    const instance = new PublicApi(apiConfig);

    timeoutInMs = timeoutInMs || instance.CORE._AXIOS.defaults.timeout;

    return {
        server: apiServer,
        apiConfig,
        timeoutInMs,
        instance
    };
};



// WEBPACK FOOTER //
// ./src/common/config/apiConfig.js